import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
// import anime from 'animejs';

export default {
    init() {
        //Stops menu from animating on load
        if (document.body.classList.contains('menu-no-animation')) {
            document.body.classList.remove('menu-no-animation');
        }
        //////////// Navigation
        const headerMenu = document.querySelector(
            '.header-menu'
        ) as HTMLElement;
        const hamburger = document.getElementById('hamburger');

        if (headerMenu && hamburger) {
            hamburger.addEventListener('click', () => {
                headerMenu.classList.toggle('open');
                hamburger.classList.toggle('close');

                if (headerMenu.classList.contains('open')) {
                    lock(headerMenu);
                } else {
                    clearBodyLocks();
                }
            });

            let lastKnownScrollPosition = window.scrollY;

            if (headerMenu.classList.contains('js-header-bg')) {
                setHeaderBg(lastKnownScrollPosition);
                document.addEventListener(
                    'scroll',
                    throttle(function () {
                        lastKnownScrollPosition = window.scrollY;
                        setHeaderBg(lastKnownScrollPosition);
                    }, 50)
                );
            }
        }

        function setHeaderBg(position: number) {
            if (position >= 150) {
                headerMenu.classList.add('bg-white');
            } else {
                headerMenu.classList.remove('bg-white');
            }
        }

        function throttle(callback: () => void, limit: number) {
            let wait = false;
            return function () {
                if (!wait) {
                    callback();
                    wait = true;
                    setTimeout(function () {
                        wait = false;
                    }, limit);
                }
            };
        }
    }
};
